// src/features/reabertura/popup/ReaberturaModal.jsx
import React from "react";
import styles from "./ReaberturaModal.module.css";

export default function ReaberturaModal({
  open,
  ids = [],
  reason,
  setReason,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  const idsText = (ids || []).join(", ");

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true">
      <div className={styles.backdrop} onClick={onClose} />

      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <div className={styles.icon} aria-hidden>
              ↩️
            </div>
            <div>
              <div className={styles.title}>
                Reabrir programação{ids.length > 1 ? "s" : ""}
              </div>
              <div className={styles.subTitle}>
                Isso muda o <b>status_wf3</b> de <b>FINALIZADO</b> para{" "}
                <b>ABERTA</b> e registra o motivo.
              </div>
            </div>
          </div>

          <button className={styles.closeBtn} onClick={onClose}>
            Fechar
          </button>
        </div>

        <div className={styles.body}>
          <label className={styles.label}>Motivo (obrigatório)</label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={6}
            className={styles.textarea}
            placeholder="Explique por que precisa reabrir…"
          />

          <div className={styles.targets}>
            <div className={styles.targetsLabel}>Alvos</div>
            <div className={styles.targetsValue} title={idsText}>
              {idsText}
            </div>
          </div>

          <div className={styles.warnBox}>
            <b>Aviso:</b> Esta ação será registrada em auditoria.
          </div>
        </div>

        <div className={styles.footer}>
          <button className={styles.cancelBtn} onClick={onClose}>
            Cancelar
          </button>

          <button className={styles.confirmBtn} onClick={onConfirm}>
            <span aria-hidden>🔓</span>
            Confirmar reabertura
          </button>
        </div>
      </div>
    </div>
  );
}
